var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgErrorSmall = function SvgErrorSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF4343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18499 8.18499C8.43163 7.93834 8.83153 7.93834 9.07817 8.18499L12 11.1068L14.9218 8.18499C15.1685 7.93834 15.5684 7.93834 15.815 8.18499C16.0617 8.43163 16.0617 8.83153 15.815 9.07817L12.8932 12L15.815 14.9218C16.0617 15.1685 16.0617 15.5684 15.815 15.815C15.5684 16.0617 15.1685 16.0617 14.9218 15.815L12 12.8932L9.07817 15.815C8.83153 16.0617 8.43163 16.0617 8.18499 15.815C7.93834 15.5684 7.93834 15.1685 8.18499 14.9218L11.1068 12L8.18499 9.07817C7.93834 8.83153 7.93834 8.43163 8.18499 8.18499Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-small.7f8e97ec.svg";
export { ForwardRef as ReactComponent };